import { ComponentName, RetailerKpiOption, RetailerKpiOptionDisplayName } from '@models/Products';
import { ButtonGroupButtonProps } from '@components/button-group-button/ButtonGroupButton';
import ButtonGroup from '@components/button-group/ButtonGroup';
import { RetailerCardDisabledProp, RetailerCardSetStateProp } from '../Types';
import {
  ChartElementName,
  ChartElementType,
  chartInteractionTrackingFunction,
  ChartInteractionTrackingFunctionParam,
  ChartInteractionTrackingFunctionParamSubset,
  useGenerateChartInteractionTrackingParam,
} from '@utils/page-analytics/model/ChartInteractionTracking';
import { capitalize } from 'lodash';
import * as styles from './ProductsRetailerButtonGroup.module.scss';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';

export const ProductsRetailerButtonGroup: React.FC<RetailerCardSetStateProp & RetailerCardDisabledProp> = ({
  selectedRetailerOption,
  setSelectedOption,
  disabled,
  clickHandler,
  getCompareProductsHeaderIcon,
  retailerClientStateKey = 'hitlistsRetailerClient',
  excludeFilter = false,
}) => {
  const chartInteractionParam = useGenerateChartInteractionTrackingParam(retailerClientStateKey);
  const { access } = usePageConfig();
  const chartInteractionTracking = (
    val: string,
    chartInteractionTrackingFunctionParamSubset: ChartInteractionTrackingFunctionParamSubset,
  ) => {
    //Start Chart Interaction Tracking
    const retailerLineChartInteractionParam = {
      ...chartInteractionTrackingFunctionParamSubset,
      optionChosen: capitalize(val),
      chartName: ComponentName.PRODUCT_TRENDS_RETAILER_LINE_CHART,
      elementName: ChartElementName.SHOW,
      elementType: ChartElementType.RADIO,
      access: access,
    } as ChartInteractionTrackingFunctionParam;

    chartInteractionTrackingFunction(retailerLineChartInteractionParam);
    //End Chart Interaction Tracking
  };

  const buttons: ButtonGroupButtonProps[] = [
    {
      id: RetailerKpiOption.share,
      title: RetailerKpiOptionDisplayName[RetailerKpiOption.share],
      text: RetailerKpiOptionDisplayName[RetailerKpiOption.share],
      onClick() {
        // Amplitude tracking for chart interaction when user toggle 'Share' option
        chartInteractionTracking(RetailerKpiOption.share, chartInteractionParam);
        setSelectedOption(RetailerKpiOption.share);
        if (clickHandler) {
          clickHandler(RetailerKpiOption.share);
        }
      },
    },
    {
      id: RetailerKpiOption.mix,
      title: RetailerKpiOptionDisplayName[RetailerKpiOption.mix],
      text: RetailerKpiOptionDisplayName[RetailerKpiOption.mix],
      onClick() {
        // Amplitude tracking for chart interaction when user toggle 'Mix' option
        chartInteractionTracking(RetailerKpiOption.mix, chartInteractionParam);
        setSelectedOption(RetailerKpiOption.mix);
        if (clickHandler) {
          clickHandler(RetailerKpiOption.mix);
        }
      },
    },
  ];

  return (
    <div className={styles.ProductsRetailerButtonGroup__ExportBtn} data-testid="products-retailer-button-group">
      {getCompareProductsHeaderIcon ? getCompareProductsHeaderIcon() : <div></div>}
      {!excludeFilter && (
        <ButtonGroup
          defaultIndex={selectedRetailerOption === RetailerKpiOption.share ? 0 : 1}
          buttons={buttons}
          disabled={disabled}
        />
      )}
    </div>
  );
};
